import { toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, resolveComponent as _resolveComponent, createVNode as _createVNode, createTextVNode as _createTextVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = { class: "w-100" }
const _hoisted_2 = { class: "pb-8 pb-lg-10" }
const _hoisted_3 = { class: "fw-bolder text-dark" }
const _hoisted_4 = { class: "mb-0 pt-15" }
const _hoisted_5 = { class: "fs-3 text-gray-600 mb-5 w-75" }
const _hoisted_6 = { class: "text-gray-400 fw-bold fs-7 pt-15" }
const _hoisted_7 = { class: "text-gray-400 fw-bold fs-6 pt-1" }
const _hoisted_8 = ["href"]
const _hoisted_9 = { class: "svg-icon svg-icon-4 ms-1 me-0" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_inline_svg = _resolveComponent("inline-svg")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      _createElementVNode("h2", _hoisted_3, _toDisplayString(_ctx.$t("We are processing your Report")), 1),
      _createElementVNode("div", _hoisted_4, [
        _createElementVNode("div", _hoisted_5, _toDisplayString(_ctx.$t(
              "Our patient relations coordinator will contact you to give more information and answer any questions you have."
            )), 1)
      ]),
      _createElementVNode("div", _hoisted_6, _toDisplayString(_ctx.$t("You can contact us any time at the number below.")), 1),
      _createElementVNode("div", _hoisted_7, [
        _createElementVNode("a", {
          href: `tel:${_ctx.$t('MassiveBioPhoneNumber')}`,
          type: "submit",
          class: "btn btn-lg btn-primary ctmscolor_background"
        }, [
          _createTextVNode(_toDisplayString(_ctx.$t("MassiveBioPhoneNumberLabel")) + " ", 1),
          _createElementVNode("span", _hoisted_9, [
            _createVNode(_component_inline_svg, { src: "/media/icons/duotune/arrows/arr064.svg" })
          ])
        ], 8, _hoisted_8)
      ])
    ])
  ]))
}